import React from "react";
import "../../css/MainPage/MainLanding.css";
import prog1 from "../../assets/header-images/prog1.jpg";
import research from "../../assets/header-images/research.jpg";
import abroad from "../../assets/header-images/abroad.jpg";
import mentorship from "../../assets/header-images/mentorship.jpg";
import conferences from "../../assets/header-images/conferences.jpg";
import allstem from "../../assets/header-images/allstem.jpg";
import apprentice from "../../assets/header-images/apprentice.jpg";
import educationalres from "../../assets/header-images/educationalres.jpg";

const trafficBoxData = [
  {
    partNumber: "1",
    title: "Research Opportunities",
    description:
      "Explore a wide range of research opportunities that allow students to work alongside experts, gain valuable hands-on experience, and contribute to cutting-edge discoveries.",
    image: research,
    link: "/programs/research-opportunities",
  },
  {
    partNumber: "2",
    title: "Study Abroad Programs",
    description:
      "Experience education from a global perspective by studying abroad. Explore different cultures, learn new languages, and gain unique insights that will enrich your academic and personal life.",
    image: abroad,
    link: "/programs/study-abroad",
  },
  {
    partNumber: "3",
    title: "Mentorship Programs",
    description:
      "Connect with experienced professionals who can guide you through your academic and career journey. Mentorship programs provide personalized advice, support, and networking opportunities.",
    image: mentorship,
    link: "/programs/mentorship-programs",
  },
  {
    partNumber: "4",
    title: "Tech Conferences",
    description:
      "Stay updated with the latest trends and advancements in technology. Attend conferences to network with industry leaders, learn from experts, and discover new career opportunities.",
    image: conferences,
    link: "/programs/tech-conferences",
  },

  {
    partNumber: "5",
    title: "All STEM Work Opportunities",
    description:
      "Explore a variety of work opportunities in STEM fields, including internships, co-ops, and full-time positions. Gain practical experience and build a professional network to advance your career.",
    image: allstem,
    link: "/programs/all-stem-work-opportunities",
  },
  {
    partNumber: "6",
    title: "Apprenticeship Programs",
    description:
      "Gain practical, hands-on experience through apprenticeship programs that offer on-the-job training, mentorship, and professional development. These programs are designed to bridge the gap between education and employment, providing a pathway to a successful career.",
    image: apprentice,
    link: "/programs/apprenticeship",
  },
  {
    partNumber: "7",
    title: "Free Educational Resources",
    description:
      "Discover a wealth of free educational resources that can enhance your learning and help you develop new skills. These resources include online courses, tutorials, e-books, and more.",
    image: educationalres,
    link: "/programs/free-learning-tools",
  },
];

const introText =
  "This page is designed to provide you with comprehensive information about various programs that can enhance your college experience and support your academic and professional growth. From research opportunities and study abroad programs to mentorship and internships, you'll find a wealth of resources to help you succeed in your chosen field. Click on each category to explore detailed information and learn how you can benefit from these resources.";

const Programs = () => {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${prog1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>Programs</h1>
          <div className="main-landing-hero-sub">
            Discover programs to enhance your college experience and career.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <p>{introText}</p>
        </div>
      </div>

      {/* Main Sections */}
      <div className="main-landing-section">
        <div className="main-landing-section-title">Explore Our Programs</div>
        <div className="main-landing-grid">
          {trafficBoxData.map((box, idx) => (
            <a key={idx} href={box.link} className="afford-college-card">
              <div className="afford-college-card-image">
                <img src={box.image} alt={box.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">{box.title}</div>
                  <div className="afford-college-card-desc">
                    {box.description}
                  </div>
                </div>
                <div className="afford-college-link-btn">Learn More</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Programs;
